import { render, staticRenderFns } from "./UserAgreementIUV.vue?vue&type=template&id=30fd2c68&scoped=true"
import script from "./UserAgreementIUV.vue?vue&type=script&lang=js"
export * from "./UserAgreementIUV.vue?vue&type=script&lang=js"
import style0 from "./UserAgreementIUV.vue?vue&type=style&index=0&id=30fd2c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fd2c68",
  null
  
)

export default component.exports